import { render } from "./AppInformation.vue?vue&type=template&id=9753fe4a&scoped=true"
import script from "./AppInformation.vue?vue&type=script&lang=js"
export * from "./AppInformation.vue?vue&type=script&lang=js"

import "./AppInformation.vue?vue&type=style&index=0&id=9753fe4a&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9753fe4a"]])

export default __exports__